export type CoreErrorCode = 'NOT_FOUND' | 'CONFLICT' | 'FORBIDDEN' | 'VALIDATION' | 'INTERNAL';

export interface CoreError {
  readonly code: CoreErrorCode;
  readonly message: string;
  readonly details?: Record<string, unknown>;
}

export const coreError = (
  code: CoreErrorCode,
  message: string,
  details?: Record<string, unknown>,
): CoreError => ({ code, message, details });

export const isCoreError = (value: unknown): value is CoreError =>
  typeof value === 'object' &&
  value !== null &&
  'code' in value &&
  'message' in value &&
  typeof (value as CoreError).code === 'string' &&
  typeof (value as CoreError).message === 'string';
